<template>
    <div style="height: 100%" class="ls_spin_container">


        <Tabs style="height: 100%" class="company__tab">
            <TabPane label="История чеков" icon="md-paper">
                <Divider></Divider>
                <historyTickets></historyTickets>
            </TabPane>
            <TabPane label="История смен" icon="md-document">
                <Divider></Divider>
                <shiftReport></shiftReport>
            </TabPane>

        </Tabs>

        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>


    import historyTickets from "@/apps/money_order/ticketHistory.vue";
    import shiftReport from "@/apps/report/shiftReport.vue";



    export default {
        name: "company",
        data() {
            return {
            };
        },
        components: {
            historyTickets,
            shiftReport
        },

    };
</script>

<style scoped>
    .company_header {
        margin-bottom: 20px;
    }


</style>


<style>
    .company__tab .ivu-tabs-nav {
        margin-bottom: 0;
    }
    .company__tab .ivu-tabs-nav .ivu-tabs-tab {
        margin-bottom: 0;
    }

    .company__tab .ivu-tabs-nav-prev {
        left: -5px;
        top: 50%;
        transform: translateY(-50%);
    }

    .company__tab .ivu-tabs-nav-next {
        right: -5px;
        top: 50%;
        transform: translateY(-50%);
    }



    @media screen and (max-width: 767px) {
        .company__tab .ivu-tabs-nav-scrollable {
            padding: 0 18px;
        }

        .company__tab .ivu-tabs-nav .ivu-tabs-tab i {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/apps/report/fiscalOperations.vue